// @flow

// Libs
import React from 'react'

// Constants
import { HEFTY_MENU } from '../constants'

// Components
import { Link } from 'react-router-dom'

// Styles
import { primary, white, dark, notAsDarkGrey } from 'hfty-styles/src/colors'

const styles = {
  link: {
    textDecoration: 'none',
    margin: '0 10px',
    padding: '5px',
    cursor: 'pointer',
    color: white(),
  },
  highlightedLink: {
    textDecoration: 'none',
    margin: '0 10px',
    padding: '5px',
    cursor: 'pointer',
    color: dark(),
  },
  drawerContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 250,
    backgroundColor: primary(),
    color: white(),
    boxShadow: '-1px 0px 1px rgba(0,0,0,0.2)',
    zIndex: 1005,
  },
  onlinkContainer: {
    padding: 15,
    backgroundColor: white(),
  },
  offlinkContainer: {
    padding: 15,
  },
  usernameContainer: {
    color: white(),
    padding: 5,
    margin: '0 10px',
  },
  userInfoContainer: {
    padding: '10px 15px',
  },
  mask: {
    zIndex: 5001,
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

type MobileProps = {
  onToggle: Function,
  activeRoute: string,
  push: Function,
  logout: Function,
  username: string,
}

export default function MobileMenu(props: MobileProps): React.Element<any> {
  const { onToggle, activeRoute, push, logout, username } = props

  return (
    <div onClick={onToggle} style={styles.mask}>
      <div style={styles.drawerContainer}>
        {HEFTY_MENU.map((infoObj: Object, index: number): React.Element<any> => {
          const linkStyle = infoObj.url === activeRoute ? styles.highlightedLink : styles.link
          const linkContainerStyle = infoObj.url === activeRoute ? styles.onlinkContainer : styles.offlinkContainer
          return (
            <div key={index} style={linkContainerStyle}>
              <Link style={linkStyle} key={infoObj.label} to={infoObj.url}>
                {infoObj.label}
              </Link>
            </div>
          )
        })}
        <div key="logMeOutMobile" style={styles.userInfoContainer}>
          <div
            style={styles.link}
            onClick={() => {
              push('/')
              logout()
              onToggle()
            }}
          >
            Logout
          </div>
        </div>
        <div style={styles.userInfoContainer}>
          <div style={styles.usernameContainer}>({username})</div>
        </div>
      </div>
    </div>
  )
}
